<template>
    <material-card class="pt-2" full-header>
        <template #heading>
            <v-toolbar color="accent">
                <v-toolbar-title>
                    <v-icon> mdi-google-classroom </v-icon>
                    {{ $t("meetings") }}
                </v-toolbar-title>

                <v-divider vertical></v-divider>
                <v-spacer></v-spacer>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn text icon dark class="mb-2" v-bind="attrs" v-on="on" @click="getMeetings">
                            <v-icon medium>mdi-refresh</v-icon>
                        </v-btn>
                    </template>
                    <span>
                        {{ $t("refresh") }}
                    </span>
                </v-tooltip>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <download-excel :fetch="exportToExcel" :fields="swapper(exportToExcelFields)"
                            :before-generate="startExport" :before-finish="finishExport">

                            <v-btn text icon  dark class="mb-2" v-bind="attrs" v-on="on"
                                :loading="excelLoading">
                                <v-icon medium>mdi-file-excel-outline</v-icon>
                            </v-btn>
                        </download-excel>
                    </template>
                    <span>
                        {{ $t('export_excel') }}
                    </span>
                </v-tooltip>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <download-excel :fetch="exportAttendeesToExcel" :fields="swapper(exportAttendeesToExcelFields)"
                            :before-generate="startExportAttendees" :before-finish="finishExportAttendees">

                            <v-btn text icon  dark class="mb-2" v-bind="attrs" v-on="on"
                                :loading="excelLoading">
                                <v-icon medium>mdi-file-document-check-outline</v-icon>
                            </v-btn>
                        </download-excel>
                    </template>
                    <span>
                        {{ $t('export_attendees_time_excel') }}
                    </span>
                </v-tooltip>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn text icon dark class="mb-2" v-bind="attrs" v-on="on" @click="showFilter = !showFilter">
                            <v-icon medium>mdi-filter</v-icon>
                        </v-btn>
                    </template>
                    <span>
                        {{ $t("filter") }}
                    </span>
                </v-tooltip>

            </v-toolbar>
        </template>
        <v-data-table :items="meetingsList" :headers="headers" :server-items-length="totalMeetings" :loading="loading"
            :options.sync="options" :items-per-page="itemPerPage" :page.sync="pageNumber" item-key="id" disable-sort :footer-props="{ showFirstLastPage: true}">
            <template v-slot:top>
                <v-expand-transition>
                    <v-sheet class="ma-3 pa-3" v-show="showFilter" dense>
                        <v-row dense flex>
                            <v-col cols="12" lg="2" md="4">
                                <v-text-field v-model="meetingNameFilter" @keydown.enter="filterMeetings()"
                                    :label="$t('meeting_name')" outlined dense hide-details clearable>
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" lg="2" md="4">
                                <v-text-field v-model="internalMeetingIdFilter" @keydown.enter="filterMeetings()"
                                    :label="$t('internal_meeting_id')" outlined dense hide-details clearable>
                                </v-text-field>
                            </v-col> 
                            <v-col cols="12" lg="2" md="4">
                                <v-text-field v-model="externalMeetingIdFilter" @keydown.enter="filterMeetings()"
                                    :label="$t('external_meeting_id')" outlined dense hide-details clearable>
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" lg="2" md="4">
                                <v-text-field v-model="serverDomainFilter" @keydown.enter="filterMeetings()"
                                    :label="$t('domain')" outlined dense hide-details clearable>
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" lg="2" md="4">
                                <v-text-field v-model="serverIpFilter" @keydown.enter="filterMeetings()" :label="$t('ip')"
                                    outlined dense hide-details clearable>
                                </v-text-field>
                            </v-col> 
                            <v-col cols="12" lg="2" md="4">
                                <v-text-field v-model="metaFilter" @keydown.enter="filterMeetings()" :label="$t('meta')"
                                    outlined dense hide-details clearable>
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" lg="2" md="4">
                                <v-text-field id="custom_start_time" v-model="startTimeFilter"
                                    @keydown.enter="filterMeetings()" :label="$t('start_time')" outlined dense hide-details
                                    append-icon="mdi-calendar" @click:append="startTimeDatePicker = true" clearable>
                                </v-text-field>
                                <date-picker v-model="startTimeFilter" element="custom_start_time" color="#00acc1"
                                    editable @close="startTimeDatePicker = false" :show="startTimeDatePicker" range>
                                </date-picker>
                            </v-col>
                            <!-- <v-col cols="12" lg="2" md="4">
                                <v-text-field id="custom_create_time" v-model="createTimeFilter"
                                    @keydown.enter="filterMeetings()" :label="$t('create_time')" outlined dense hide-details
                                    append-icon="mdi-calendar" @click:append="createTimeDatePicker = true" clearable>
                                </v-text-field>
                                <date-picker v-model="createTimeFilter" element="custom_create_time" color="#00acc1"
                                    editable @close="createTimeDatePicker = false" :show="createTimeDatePicker" range>
                                </date-picker>
                            </v-col> -->
                            <v-col cols="12" lg="1" md="4">
                                <v-btn rounded @click="filterMeetings" color="primary" :loading="loading">
                                    <v-icon> mdi-filter </v-icon>
                                    {{ $t("filter") }}
                                </v-btn>
                            </v-col>

                        </v-row>
                    </v-sheet>
                </v-expand-transition>
            </template>
            <template v-slot:[`item.internal_meeting_id`]="{ item }">
               <div class="my-2">{{ item.internal_meeting_id }}</div>
               <v-divider  class="my-1"></v-divider>
               <div class="my-2">{{ item.meeting_id }}</div>
            </template>
            <template v-slot:[`item.dashboard`]="{ item }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn class="ma-2" text icon v-bind="attrs" v-on="on" :disabled="!hasPermission('virtual_machine_learning_dashboard_json_get')">
                            <v-icon color="primary" medium
                                @click="openLearningDashboard(item, attrs)">mdi-monitor-dashboard</v-icon>
                        </v-btn>
                    </template>
                    <span>{{ $t("learning_dashboard") }}</span>
                </v-tooltip>
            </template>
            <template v-slot:[`item.meta`]="{ item }" >
                <div class="leftToRight">
                    <json-viewer :expand-depth=0 :value="item.meta" ></json-viewer>
                </div>
            </template> 
            <template v-slot:[`item.start_time`]="{ item }" >
               {{  item.start_time}} <br>
               {{ item.create_time }}
            </template>
        </v-data-table>

    </material-card>
</template>
<script>
import {swap} from '../util/func'
import {getMeetingsList,getAttendees} from '../services/meetingsService'
import permissions from '../mixins/permissions';
export default {
    mixins:[permissions],
    props: ["data"],
    data() {
        return {
            loading: false,
            headers: [
                { text: this.$t('meeting_name'), value: 'meeting_name' },
                { text: this.$t('meeting_id'), value: 'internal_meeting_id'},
                { text: this.$t('domain'), value: 'virtual_machine.domain' },
                { text: this.$t('ip'), value: 'virtual_machine.ip' },
                { text: this.$t('start_time'), value: 'start_time' },
                // { text: this.$t('create_time'), value: 'create_time' },
                { text: this.$t('meta'), value: 'meta' },
                { text: this.$t('duration'), value: 'duration' },
                { text: this.$t('recording'), value: 'recording' },
                { text: this.$t('dashboard'), value: 'dashboard' },
            ],
            exportToExcelFields: {
                'meeting_name': this.$t('meeting_name'),
                'internal_meeting_id': this.$t('internal_meeting_id'),
                'meeting_id': this.$t('external_meeting_id'),
                'virtual_machine.domain': this.$t('domain'),
                'virtual_machine.ip': this.$t('ip'),
                'start_time': this.$t('start_time'),
                'create_time': this.$t('create_time'),
                'duration': this.$t('duration'),
                'recording': this.$t('recording'),
            }, 
            exportAttendeesToExcelFields: {
                'meeting_name': this.$t('meeting_name'),
                'create_on': this.$t('created_at'),
                'user_name':this.$t('name'),
                'user_role':this.$t('role'),
                'ids':this.$t('register_left_count'),
                'register_left':this.$t('register_left'),
            },
            meetingsList: [],
            totalMeetings: 0,
            options: {},
            itemPerPage: 10,
            pageNumber: 1,
            startRow: 0,
            endRow: 10,
            showFilter: true,
            meetingIdFilter: '',
            internalMeetingIdFilter: '',
            externalMeetingIdFilter: this?.data?.meetingId,
            meetingNameFilter: '',
            serverDomainFilter: '',
            createTimeFilter: '',
            startTimeFilter: '',//['1403/09/06','1403/09/06'],
            serverIpFilter: '',
            metaFilter: '',
            startTimeDatePicker: false,
            createTimeDatePicker: false,
            fetchMeetingsDialog: false,
            fetchMeetingDialog: false,
            meeting: {},
            allInformationDialog: false,
            learningDashboardLoading: false,
            selectedItem: null,
            exprtExcelData:null,
            excelLoading:false
        }
    },
    watch: {
        options: {
            handler() {
                this.getMeetings();
            },
            deep: true,
        },
    },
    methods: {
        filterMeetings(){
            if(this.pageNumber!=1)
                this.pageNumber=1;
            else
             this.getMeetings();
        },
        getPayload(){
            const { page, itemsPerPage } = this.options;
            const payload = { page, itemsPerPage };
            if (this.externalMeetingIdFilter != "") payload["meeting_id"] = this.externalMeetingIdFilter;
            if (this.createTimeFilter != "") payload["create_time"] = this.createTimeFilter;
            if (this.startTimeFilter != "") payload["start_time"] = this.startTimeFilter;
            if (this.internalMeetingIdFilter != "") payload["internal_meeting_id"] = this.internalMeetingIdFilter;
            if (this.meetingNameFilter != "") payload["meeting_name"] = this.meetingNameFilter;
            if (this.serverDomainFilter != "") payload["server_domain"] = this.serverDomainFilter;
            if (this.serverIpFilter != "") payload["server_ip"] = this.serverIpFilter;
            if (this.metaFilter != "") payload["meta"] = this.metaFilter;
            return payload;
        },
        getMeetings() {
            this.loading=true;
            getMeetingsList(this.getPayload())
                .then((response) => {
                    const data = response.data;
                    this.meetingsList = data.data;
                    this.totalMeetings = data.totalRows;
                    this.loading = false;
                    
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(()=>{
                    this.loading=false;
                });
        },
        async exportToExcel(){
            let payload=this.getPayload();
            payload['itemsPerPage']=this.totalMeetings;
            const response= await getMeetingsList(payload);
            console.log(response.data)
            return response.data.data
        },
        async exportAttendeesToExcel(){
            let payload=this.getPayload();
            payload['itemsPerPage']=this.totalMeetings;
            const response= await getAttendees(payload);
            console.log(response.data)
            return response.data.data
        },
        openLearningDashboard(item) {
            console.log(item);
            //  this.selectedItem = item;
            window.open("/learningDashboard?url=" + 'https://learning-dashboard.borka.ir/?vm=' + item.virtual_machine_id
                + '&meeting=' + item.internal_meeting_id
                + '&lang=fa-IR&origin=' + location.origin, '_blank');

            /* let getUrl = getLearningDashboard(item.internal_meeting_id, item.virtual_machine_id);
            getUrl.then((response) => {
                const routeData = this.$router.resolve({ name: 'dashboard', params: { 'url': response.data.url } });
                console.log(routeData);
               
            }).catch((error) => {
                console.log(error);
            }).finally(() => {
                this.selectedItem = null;
            }); */
        },
        getDashboardLoading(item) {
            if (item == this.selectedItem)
                return true;
            else return false;
        },
        swapper:swap,
        startExport() {
            this.excelLoading = true;
        },
        finishExport() {
            this.excelLoading = false;
        },
        startExportAttendees() {
            this.excelLoading = true;
        },
        finishExportAttendees() {
            this.excelLoading = false;
        }
    }
}
</script>
<style>
.meeting{
    width: 100px !important;
    word-wrap: break-word;
}
.leftToRight {
    direction: ltr !important;
}
</style>